import React from "react";

import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { ICellRenderProps, IShowPositiveNegative } from "./interface";

export const withPositiveNegative = (Component: React.FC<ICellRenderProps>) => {
  return ({ onlyNegative, realValue, value, ...props }: IShowPositiveNegative) => {
    const theme = useTheme();

    if (!value) return <Component {...props} />;

    const getColor = () => {
      if (realValue === 0 || !realValue) return undefined;
      if (onlyNegative && realValue > 0) return undefined;

      return realValue > 0
        ? theme.palette.success.main
        : theme.palette.error.main;
    };

    const color = getColor();

    return (
      <Typography
        sx={{ color, fontFamily: 'var(--monospace)', fontSize: '0.84rem' }}
        fontWeight="inherit"
      >
        {value}
      </Typography>
    );
  };
}